import {z} from 'zod'
import {tokenInfoSchema} from 'types/TokenInfo'
import {chartPreferencesSchema} from './ChartPreferences'
import {genericPaylinkButtonConfigSolutionSchema} from './GenericPaylinkButton'
import {legacyUserPreferencesSchema} from './preferences/migration/schemas/legacyUserPreferencesSchema'

export enum LocalStorageKey {
  TOKEN = 'token',
  STRIPE_STATE_PARAM = 'stripe_state_param',
  PAYPAL_REFERRAL_TOKEN = 'paypal_referral_token',
  PENDING_EMAIL_ADDRESS = 'pending_email_address',
  SHOW_SUPPORT_CLUBS_MODAL = 'show_support_clubs_modal',
  SHOW_WELCOME_MODAL = 'show_welcome_modal',
  AUTHY_ALERT_MODAL_DISMISSED = 'authy_alert_modal_dismissed',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_USER_PREFERENCES = 'user_preferences',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_ORGANISATION_NOT_APPROVED_NOTIFICATION_SHOWN = 'organisation_not_approved_notification_shown',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_SHOW_SOLUTION_SETTINGS_TOUR = 'show_solution_settings_tour',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_SHOW_WELCOME_DASHBOARD_MODAL = 'show_welcome_dashboard_modal',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_SHOW_WELCOME_SOLUTIONS_MODAL = 'show_welcome_solutions_modal',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_SURVEY_ANSWERED = 'survey_answered',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_GENERIC_PAYLINK_BUTTON_CONFIG = 'generic_paylink_button_config',

  /**
   * @deprecated moved to user preferences
   */
  LEGACY_UI = 'ui',
}

/**
 * The following is a map of the local storage keys to their validation schemas
 */
export const localStorageSchemas = {
  [LocalStorageKey.TOKEN]: tokenInfoSchema,
  [LocalStorageKey.STRIPE_STATE_PARAM]: z.string(),
  [LocalStorageKey.PAYPAL_REFERRAL_TOKEN]: z.string(),
  [LocalStorageKey.PENDING_EMAIL_ADDRESS]: z.object({
    value: z.string(),
    expiry: z.number(),
  }),
  [LocalStorageKey.SHOW_SUPPORT_CLUBS_MODAL]: z.boolean(),
  [LocalStorageKey.SHOW_WELCOME_MODAL]: z.boolean(),
  [LocalStorageKey.AUTHY_ALERT_MODAL_DISMISSED]: z.boolean(),

  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_USER_PREFERENCES]: legacyUserPreferencesSchema,
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_ORGANISATION_NOT_APPROVED_NOTIFICATION_SHOWN]:
    z.boolean(),
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_SHOW_SOLUTION_SETTINGS_TOUR]: z.boolean(),
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_SHOW_WELCOME_DASHBOARD_MODAL]: z.boolean(),
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_SHOW_WELCOME_SOLUTIONS_MODAL]: z.boolean(),
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_SURVEY_ANSWERED]: z.boolean(),
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_GENERIC_PAYLINK_BUTTON_CONFIG]:
    genericPaylinkButtonConfigSolutionSchema,
  // eslint-disable-next-line deprecation/deprecation
  [LocalStorageKey.LEGACY_UI]: chartPreferencesSchema,
} satisfies Record<LocalStorageKey, z.ZodSchema>
